import { useMutation } from "@apollo/client";
import { Modal, notification } from "@pankod/refine-antd";
import { HANDLE_CASK_OWNER_REQUEST } from "apollo";
import {
  handleCaskOwnerRequest,
  handleCaskOwnerRequestVariables,
} from "schemaTypes";

export const useCaskOwnerRequest = () => {
  const [request] = useMutation<
    handleCaskOwnerRequest,
    handleCaskOwnerRequestVariables
  >(HANDLE_CASK_OWNER_REQUEST);

  const approve = (id: string, owner: string, cb?: Function) => {
    Modal.confirm({
      title: "Confirmation",
      content: `You will approve Cask Owner request for ${owner}`,
      onOk: async () => {
        await request({
          variables: {
            input: {
              _id: id,
              approved: true,
            },
          },
        });

        notification.success({ message: "Successfully approved" });
        if (cb) cb();
      },
    });
  };
  const reject = (id: string, owner: string, cb?: Function) => {
    Modal.confirm({
      title: "Confirmation",
      content: `You will reject Cask Owner request for ${owner}`,
      onOk: async () => {
        await request({
          variables: {
            input: {
              _id: id,
              approved: false,
            },
          },
        });

        notification.success({ message: "Successfully rejected" });
        if (cb) cb();
      },
    });
  };

  return { approve, reject };
};
